import React, { useCallback, useContext } from 'react';
import ReactDOM from 'react-dom';
import { message } from 'antd';
import { DESIGN_ELEMENT_LAYER_DROPDOWN } from '../../../artboard/ContextMenu/translationValues';
import { PageElementsContext } from '../../../context/pageElementsContext';
import { MenuListItem } from '../../../artboard/ContextMenu/styles';
import { useDocumentContext } from '../../../context/complexDocumentContext';

const GridContextMenu = (props) => {

  const { updateComplexElementDetails, copyGridElement, pasteGridElements, deleteCellContnet  } = useContext(PageElementsContext);
  const { t, itemUUID, selectedRange, setSelectedRange, startCell, setSelectedCell, tableRef, copiedCellsRef, parentUUID, setContextMenu } = props;

  const [, methods] = useDocumentContext(()=>null);
  
  const onMergeCells = useCallback(() => {
    setSelectedRange((selectedRange) => {
      updateComplexElementDetails(
        itemUUID,
        {
          selectedRange
        },
        'static-table-merge-cells'
      );
      setSelectedCell(undefined);
      return undefined;
    })
  }, []);

  const onSplitCells = useCallback(() => {
    setSelectedRange((selectedRange) => {
      updateComplexElementDetails(
        itemUUID,
        {
          selectedRange,
          refElement: tableRef.current,
          isBlock: true
        },
        'static-table-split-cells'
      );
      setSelectedCell(undefined);
      return undefined;
    })
  }, []);

  const onDeleteColumns = useCallback((e) => { // TODO : Delete column changes column width values in terms of percentage
    setSelectedRange((selectedRange) => {
      updateComplexElementDetails(
        itemUUID,
        {
          selectedRange,
          prevent: () => {
            message.warn(t(DESIGN_ELEMENT_LAYER_DROPDOWN.DELETE_ALL_COLUMN_WARN.key, DESIGN_ELEMENT_LAYER_DROPDOWN.DELETE_ALL_COLUMN_WARN.value));
          },
          refElement: tableRef.current
        },
        'static-block-delete-columns'
      );
      setSelectedCell(undefined);
      return undefined;
    })
  }, []);

  const onDeleteRows = useCallback((e) => {
    setSelectedRange((selectedRange) => {
      updateComplexElementDetails(
        itemUUID,
        {
          selectedRange,
          prevent: () => {
            message.warn(t(DESIGN_ELEMENT_LAYER_DROPDOWN.DELETE_ALL_ROW_WARN.key, DESIGN_ELEMENT_LAYER_DROPDOWN.DELETE_ALL_ROW_WARN.value));
          },
          refElement: tableRef.current
        },
        'static-table-delete-rows'
      );
      setSelectedCell(undefined);
      return undefined;
    })
  }, []);

  const onDuplicateRow = useCallback((e) => {
    setSelectedRange((selectedRange) => {
      updateComplexElementDetails(
        itemUUID,
        {
          selectedRange
        },
        'static-table-duplicate-rows'
      );
      setSelectedCell(undefined);
      return undefined;
    })
  }, []);

  const onDuplicateColumns = useCallback((e) => {
    setSelectedRange((selectedRange) => {
      updateComplexElementDetails(
        itemUUID,
        {
          selectedRange
        },
        'static-table-duplicate-cols'
      );
      setSelectedCell(undefined);
      return undefined;
    })
  }, []);
  const onCopyCells = useCallback(e => {
    const copiedUUIDs = copyGridElement({ ...selectedRange });
    copiedCellsRef.current = copiedUUIDs;
    setContextMenu(false);
  });

  const onPasteCells = useCallback(async e => {
    if (copiedCellsRef.current) {
      pasteGridElements(
        selectedRange,
        copiedCellsRef.current,
        methods,
        itemUUID,
        parentUUID,
        () => {
          setTimeout(() => {
            copiedCellsRef.current = null;
            setSelectedRange(undefined);
          }, 100);
        },
      );
    }
    setContextMenu(false);
  });

  const onDeleteCellContent = useCallback(e => {
    deleteCellContnet({ ...selectedRange }, itemUUID, parentUUID, methods);
    setContextMenu(false);
  });

  const contextMenuDOM = document.getElementById('extraMenuItems');

  return (
    <>
      {contextMenuDOM && ReactDOM.createPortal(
        <>
        {selectedRange?.start && (
          <MenuListItem onClick={onDeleteCellContent}>
            {t(
              DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DELETE.key,
              DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DELETE.value,
            )}
          </MenuListItem>
        )}
        {copiedCellsRef.current && (
          <MenuListItem onClick={onPasteCells}>
            {t(
              DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_PASTE.key,
              DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_PASTE.value,
            )}
          </MenuListItem>
        )}
        {selectedRange?.end && (<MenuListItem
          onClick={onMergeCells}
        >
          {t(
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_MERGE.key,
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_MERGE.value,
          )}
        </MenuListItem>)}
        {(startCell?.rowSpan > 1 || startCell?.columnSpan > 1) && (<MenuListItem
          onClick={onSplitCells}
        >
          {t(
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_UNMERGE.key,
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_UNMERGE.value,
          )}
        </MenuListItem>)}
        {startCell && (
          <>
            <MenuListItem onClick={onCopyCells}>
              {t(
                DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_COPY.key,
                DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_COPY.value,
              )}
            </MenuListItem>
            <MenuListItem onClick={onDeleteRows}>
              {t(
                DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DELETE_ROW.key,
                DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DELETE_ROW.value,
              )}
            </MenuListItem>
          </>
        )}
        {startCell && (<MenuListItem
          onClick={onDeleteColumns}
        >
          {t(
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DELETE_COLUMN.key,
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DELETE_COLUMN.value,
          )}
        </MenuListItem>)}
        {startCell && (<MenuListItem
          onClick={onDuplicateRow}
        >
          {t(
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DUPLICATE_ROW.key,
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DUPLICATE_ROW.value,
          )}
        </MenuListItem>)}
        {startCell && (<MenuListItem
          onClick={onDuplicateColumns}
        >
          {t(
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DUPLICATE_COLUMN.key,
            DESIGN_ELEMENT_LAYER_DROPDOWN.STATIC_TABLE_DUPLICATE_COLUMN.value,
          )}
        </MenuListItem>)}
        </>,
        contextMenuDOM
      )}
    </>
  )
}

export default GridContextMenu;